export const main = {
  notice: 'Bestell- und Verwaltungslösungen für Restaurants',
  notice_2: 'eine Website oder einen Webshop für dein Restaurant in wenigen Minuten',
  logo_alt: 'Bistroo',
  login_text: 'Anmelden',
  login_text_mobile: 'Restaurant anmelden',
  start_free_text: 'Kostenlos starten',
  actions: {
    create_your_shop: 'Erstelle deinen Webshop',
    product_demo: 'Produktdemo',
  },
  menu: {
    home: { text: 'Home' },
    products: {
      text: 'Produkte',
      submenu: {
        manager: { text: 'Bistroo Manager', subtext: 'Alle Tools vollständig in eigener Verwaltung' },
        qr: { text: 'Bistroo QR', subtext: 'Ein kosteneffizienter Tischbestellprozess' },
        webshop: { text: 'Bistroo Webshop', subtext: 'Der Webshop für dein Restaurant' },
        pos: { text: 'Bistroo Kasse', subtext: 'Superschnelle Kasse für Quick-Service' },
        posdevice: { text: 'Bistroo Device', subtext: 'Plug & Play bestellen und drucken' },
        page: { text: 'Bistroo Website', subtext: 'Erstelle in wenigen Minuten eine Website' },
        kiosk: { text: 'Bistroo Kiosk', subtext: 'Selbstbedienung in deinem Restaurant' },
      },
    },
    prices: { text: 'Preise' },
    cases: {
      text: 'Cases',
      submenu: {
        cafetaria: { text: "Cafetaria D'n Boom", subtext: 'Wie Bistroo half, den Umsatz zu steigern.' },
        grillroom: { text: 'Grillroom Istanbul', subtext: 'Endlich ein faires Geschäftsmodell.' },
        sushi: { text: 'Sushi De wethouder', subtext: 'Ein Partner, dem wir 24/7 vertrauen können.' },
        italian: { text: 'Italiaan Il Municipio', subtext: 'Eine neue Lösung und neue Möglichkeiten.' },
        lunchroom: { text: 'Lunchroom Two-B', subtext: 'Wir haben viel Zeit und Frustration gespart.' },
      },
    },
    info: {
      text: 'Info',
      submenu: {
        helpcenter: { text: 'Hilfezentrum', subtext: 'Alle Informationen, die du benötigst' },
        integrations: { text: 'Integrationen', subtext: 'Unsere Partnerintegrationen' },
        downloads: { text: 'Downloads', subtext: 'Die neuesten App-Updates' },
        articles: { text: 'Artikel', subtext: 'Aktuelle Branchenupdates' },
        faq: { text: 'FAQ', subtext: 'Häufig gestellte Fragen' },
        blog: { text: 'Blog', subtext: 'Aktuelle Infos & Trends' },
        support: { text: 'Kundenservice', subtext: 'Wir helfen dir gerne weiter' },
        contact: { text: 'Kontakt', subtext: 'Wir helfen dir gerne weiter' },
      },
    },
  },
  cta_block: {
    open_your_webshop_today: 'Öffne deinen Shop heute.',
    its_free: 'Es ist kostenlos!',
    start_generating_more_orders: 'Generiere deine erste Bestellung in wenigen Minuten',
    get_started_for_free: 'Kostenlos starten',
  },
  footer: {
    general: 'Allgemein',
    products: 'Produkte',
    cases: 'Cases',
    info: 'Informationen',
  },
  product_faq: {
    label: 'Häufig gestellte Fragen',
    not_listed: 'Deine Frage ist nicht dabei? Kontaktiere unser Support-Team.',
  },
  integration: {
    back_link: 'Alle Integrationen',
    advantages_label: 'Vorteile',
    setup_label: 'In 5 Schritten einrichten',
    faq_heading: 'Häufig gestellte Fragen',
    more_info: 'Mehr Infos',
    check_1: 'Unverbindlich, monatlich kündbar',
    check_2: 'Einrichtung in wenigen Minuten',
    advantages_subtitle: 'Leistungsstarke Funktionen, die nahtlos zusammenarbeiten, um deinen Restaurantbetrieb zu optimieren',
    cta_footer_text: 'Einrichtung in weniger als 10 Minuten · Jederzeit kündbar',
    related: {
      eyebrow: 'Sieh auch',
      title: 'Ähnliche Integrationen',
      description: 'Bistroo arbeitet mit den besten Tools zusammen. Kombiniere mehrere Integrationen für einen vollständig automatisierten Gastronomiebetrieb.',
    },
    cta: {
      heading: 'Öffne deinen Shop noch heute.',
      free: 'Kostenlos.',
      subtext: 'Mehr Bestellungen, weniger Arbeit.',
      button: 'Kostenlos starten',
    },
  },
}
